export interface CompaniesContainerProps {
  loadingIsBeginningCallback: () => void
  loadingHasEndedCallback: () => void
}
